import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SeoManager from "@/components/feature/SeoManager";
import { SectionViewProvider } from "@/components/feature/SectionViewProvider";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SectionViewProvider>
          <SeoManager />
          <div className="min-h-screen flex flex-col bg-background-50">
            <Navbar />
            <main className="flex-1">
              <AppRoutes />
            </main>
            <Footer />
          </div>
        </SectionViewProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;